import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("—")
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("—")
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("—")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("—")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("—")
const _hoisted_10 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_11 = { class: "p-fluid" }
const _hoisted_12 = { class: "p-fluid" }
const _hoisted_13 = { class: "p-fluid" }
const _hoisted_14 = { class: "p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_PrimeVueColumn = _resolveComponent("PrimeVueColumn")!
  const _component_PrimeVueTag = _resolveComponent("PrimeVueTag")!
  const _component_EntriesDataTable = _resolveComponent("EntriesDataTable")!
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_Entries = _resolveComponent("Entries")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Entries, {
    title: _ctx.$t('adsecure'),
    "show-add-button": false,
    "show-filters-button": _ctx.showRelationsColumns,
    "href-prefix": "adsecure"
  }, _createSlots({
    tables: _withCtx(() => [
      _createVNode(_component_EntriesDataTable, {
        entries: _ctx.adSecureAnalyzes,
        "entries-handler": _ctx.fetchAdSecureAnalyzes,
        "show-edit-button": false,
        "href-prefix": "adsecure"
      }, {
        actions: _withCtx(({ data }) => [
          (data.analysis_public_url)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: data.analysis_public_url,
                target: "_blank"
              }, [
                _createVNode(_component_PrimeVueButton, {
                  class: "p-button-rounded p-button-text p-button-secondary",
                  icon: "pi pi-external-link"
                })
              ], 8, _hoisted_1))
            : _createCommentVNode("", true)
        ]),
        columns: _withCtx(() => [
          (_ctx.user.isSuperAdmin() && _ctx.showRelationsColumns)
            ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                key: 0,
                field: "project_id",
                header: _ctx.$t('project'),
                sortable: ""
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(data.project.name), 1)
                ]),
                _: 1
              }, 8, ["header"]))
            : _createCommentVNode("", true),
          (_ctx.showRelationsColumns)
            ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                key: 1,
                field: "user_id",
                header: _ctx.$t('user'),
                sortable: ""
              }, {
                body: _withCtx(({ data }) => [
                  (data.user_id)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: `/users/${data.user_id}`,
                        target: "_blank"
                      }, _toDisplayString(data.user.email), 9, _hoisted_2))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_3
                      ], 64))
                ]),
                _: 1
              }, 8, ["header"]))
            : _createCommentVNode("", true),
          (_ctx.showRelationsColumns)
            ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                key: 2,
                field: "campaign_id",
                header: _ctx.$t('campaign'),
                sortable: ""
              }, {
                body: _withCtx(({ data }) => [
                  (data.campaign_id)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: `/campaigns/${data.campaign_id}`,
                        target: "_blank"
                      }, _toDisplayString(data.campaign.compiled_name), 9, _hoisted_4))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_5
                      ], 64))
                ]),
                _: 1
              }, 8, ["header"]))
            : _createCommentVNode("", true),
          (_ctx.showRelationsColumns)
            ? (_openBlock(), _createBlock(_component_PrimeVueColumn, {
                key: 3,
                field: "feed_id",
                header: _ctx.$t('feed'),
                sortable: ""
              }, {
                body: _withCtx(({ data }) => [
                  (data.feed_id)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: `/feeds/${data.feed_id}`,
                        target: "_blank"
                      }, _toDisplayString(data.feed.compiled_name), 9, _hoisted_6))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_7
                      ], 64))
                ]),
                _: 1
              }, 8, ["header"]))
            : _createCommentVNode("", true),
          _createVNode(_component_PrimeVueColumn, {
            field: "country_alpha3code",
            header: _ctx.$t('country'),
            sortable: ""
          }, {
            body: _withCtx(({ data }) => [
              (data.country_alpha3code)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(data.country_alpha3code), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_8
                  ], 64))
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_PrimeVueColumn, {
            field: "device_name",
            header: "Device",
            sortable: ""
          }, {
            body: _withCtx(({ data }) => [
              (data.device_name)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(data.device_name), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_9
                  ], 64))
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeVueColumn, {
            field: "status",
            header: _ctx.$t('status'),
            sortable: ""
          }, {
            body: _withCtx(({ data }) => [
              (data.alert)
                ? _withDirectives((_openBlock(), _createBlock(_component_PrimeVueTag, {
                    key: 0,
                    class: "mr-2",
                    severity: "warning",
                    value: "🚨"
                  }, null, 512)), [
                    [_directive_tooltip, _ctx.$t('has_violations')]
                  ])
                : _createCommentVNode("", true),
              _createVNode(_component_PrimeVueTag, {
                value: _ctx.$t(_ctx.ADSECURE_ANALYSIS_STATUSES_MAP[data.status].translate_key),
                severity: _ctx.ADSECURE_ANALYSIS_STATUSES_MAP[data.status].severity
              }, null, 8, ["value", "severity"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_PrimeVueColumn, {
            field: "updated_at",
            header: _ctx.$t('updated_at'),
            sortable: ""
          }, null, 8, ["header"])
        ]),
        _: 1
      }, 8, ["entries", "entries-handler"])
    ]),
    _: 2
  }, [
    (_ctx.showRelationsColumns)
      ? {
          name: "filters",
          fn: _withCtx(() => [
            (_ctx.user.isSuperAdmin())
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_FieldDropdownNext, {
                    modelValue: _ctx.adSecureAnalyzesFilters.project_id,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.adSecureAnalyzesFilters.project_id) = $event)),
                      _ctx.onProjectChange
                    ],
                    modelModifiers: { number: true },
                    label: _ctx.$t('project'),
                    loading: _ctx.projectsLoading,
                    "show-clear": "",
                    options: _ctx.projects.data,
                    "option-value": "id",
                    "option-label": "name"
                  }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.adSecureAnalyzesFilters.user_id,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.adSecureAnalyzesFilters.user_id) = $event)),
                  _ctx.onUserChange
                ],
                modelModifiers: { number: true },
                label: _ctx.$t('user'),
                loading: _ctx.usersLoading,
                "show-clear": "",
                filter: true,
                options: _ctx.users.data,
                "option-value": "id",
                "option-label": "compiled_name"
              }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.adSecureAnalyzesFilters.campaign_id,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.adSecureAnalyzesFilters.campaign_id) = $event)),
                label: _ctx.$t('campaign'),
                loading: _ctx.campaignsLoading,
                "show-clear": "",
                filter: true,
                options: _ctx.campaigns.data,
                "option-value": "id",
                "option-label": "compiled_name"
              }, null, 8, ["modelValue", "label", "loading", "options"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_FieldDropdownNext, {
                modelValue: _ctx.adSecureAnalyzesFilters.feed_id,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.adSecureAnalyzesFilters.feed_id) = $event)),
                label: _ctx.$t('feed'),
                loading: _ctx.feedsLoading,
                "show-clear": "",
                filter: true,
                options: _ctx.feeds.data,
                "option-value": "id",
                "option-label": "compiled_name"
              }, null, 8, ["modelValue", "label", "loading", "options"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_FieldText, {
                modelValue: _ctx.adSecureAnalyzesFilters.url,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.adSecureAnalyzesFilters.url) = $event)),
                modelModifiers: { trim: true },
                label: "URL"
              }, null, 8, ["modelValue"])
            ])
          ])
        }
      : undefined
  ]), 1032, ["title", "show-filters-button"]))
}